import { createStore } from 'vuex'
import mediaReturn from './mediaReturn'
import requestUrl from '@/config'
import apiClient from '@/utils/client'

export default createStore({
  state: {
    renderType: 'normal',
    dslData: {},
    currentPageDsl: {},
    pageInteractiveData: {}, // 当前页面交互存储信息（手机号、验证码，smsToken）
    publicOfficialInfo: {}, // 公众号信息
    userInfo: {}, // 用户信息
    peerInfo: {}, // 同行/黑产信息
  },
  getters: {},
  mutations: {
    setDslData(state, payload) {
      state.dslData = payload
    },
    setRenderType(state, { renderType = 'normal' }) {
      state.renderType = renderType
    },
    setCurrentPageDsl(state, dslContent) {
      state.currentPageDsl = dslContent
    },
    // 传入当前页面的id与子页面subId 返回当前两个id确定出来的pageDsl，进行页面渲染
    getPageDslByPageId(state, { id, subId }) {
      if (subId) {
        state.currentPageDsl = state.dslData?.pageTreeDsl?.children?.find(
          (item) => item.pageId == subId
        ) || { dslContent: [] }
        return state.currentPageDsl
      } else {
        state.currentPageDsl =
          state.dslData.pageTreeDsl.pageId === id
            ? state.dslData.pageTreeDsl
            : { dslContent: [] }
        return state.currentPageDsl
      }
    },
    setPageInteractiveData(state, payload) {
      state.pageInteractiveData = Object.assign(
        state.pageInteractiveData,
        payload,
      )
    },
    setPublicOfficialInfo(state, payload) {
      state.publicOfficialInfo = payload
    },
    setUserInfo(state, payload) {
      state.userInfo = Object.assign(
        state.userInfo,
        payload,
      )
    },
    setPeerInfo(state, payload) {
      state.peerInfo = payload
    },
  },
  actions: {
    // 获取小程序path
    fetchMiniPath(action, params) {
      return apiClient.postWithSignJson(requestUrl.GET_MINI_LINK, params, true)
    },
    // 发送验证码
    getSendMsgApi(action, params) {
      return apiClient.postWithSign(requestUrl.SEND_MSG_API, params, false)
    },
    // 登录
    login(action, params) {
      return apiClient.postWithSign(requestUrl.LOGIN, params, true)
    },
    // 获取二维码（无unionid）
    getQrcodeWithoutBid(action, params) {
      return apiClient.getWithSign(
        requestUrl.GET_QRCODE + '/' + params.bid,
        null,
        true
      )
    },
    // 获取通用防重复接口（有unionId）
    getCommonResourceQrcode(action, params) {
      return apiClient.getWithSignSecure(
        requestUrl.COMMON_RESOURCE,
        params,
        false
      )
    },
    // 获取公众号信息
    getPublicOfficialInfo(action, params) {
      return apiClient.getWithSign(
        requestUrl.GET_PUBLIC_OFFICIAL_INFO,
        params,
        true
      )
    },
    // 通过token获取用户信息
    getUserByToken(action, params) {
      return apiClient.getWithSign(requestUrl.GET_USER_BY_TOKEN, params, false)
    },
    // 通过code获取用户信息
    getUserByCode(action, params) {
      return apiClient.getWithSign(requestUrl.GET_USER_BY_CODE, params, false)
    },
    // 获取微信客服链接
    getWxLink(action, params) {
      return apiClient.postWithSignJson(requestUrl.GET_WX_LINK, params, true)
    },
    // 获取同行/黑产状态
    async getPeerStatus(action, params) {
      let peerStatus
      const res = await apiClient.getWithSignSecure(
        requestUrl.QUERY_PEER,
        params,
        false
      )
      // 同行状态保存
      switch (res && res.data && res.data.peerStatus) {
        case 1:
          peerStatus = 100
          break
        case 0:
          peerStatus = 300
          break
        default:
          peerStatus = (res && res.data && res.data.peerStatus) || ''
          break
      }

      action.commit('setPeerInfo', {
        blacklist: res?.data?.status === 0 ? true : false,
        isPeers: res?.data?.peerStatus === 0 ? true : false,
        peerStatus,
      })
    },
    // 获取页面详情信息接口
    async fetchPageInfo(action, params) {
      try {
        const { code, data } = await apiClient.getWithSign(
          requestUrl.FETCH_PAGE_INFO,
          params,
          false
        )
        if (code === 1 && data?.detail) {
          action.commit('setDslData', JSON.parse(data.detail))
        } else throw new Error('获取页面信息失败')
      } catch (err) {
        throw new Error('获取页面信息失败')
      }
    },
    // 获取页面vaster位置类型
    async getVasterPosition(action, params) {
      return apiClient.getWithSignSecure(
        requestUrl.VASTER_BANNER,
        params,
        false
      )
    },
  },
  modules: {
    mediaReturn,
  },
})
